import { type Listing } from '@ev-tech/search-modules-api';

import { type ListingFeatureDescriptor } from './types';
import { PROPERTY_FEATURES } from '../propertyFeatures';

export function getListingFeatures(listing: Listing): ListingFeatureDescriptor[] {
  const descriptors: ListingFeatureDescriptor[] = [];
  for (const feature of PROPERTY_FEATURES) {
    if (feature.condition(listing)) {
      descriptors.push({
        fieldName: feature.fieldName,
        labelKey: feature.labelKey,
        value: true,
      });
    }
  }
  return descriptors;
}
